import React from "react";
import { EuiButton, EuiModal, EuiModalBody, EuiModalFooter, EuiModalHeader, EuiModalHeaderTitle, EuiOverlayMask } from "@elastic/eui";


export const ConfirmRemove = (props) =>{

  let {open, onConfirm, onlyConfirm} = props;

  return open ? (
    <EuiOverlayMask>
      <EuiModal onClose={()=>onConfirm(undefined)} maxWidth={false}>
        <EuiModalHeader>
          <EuiModalHeaderTitle>{"Eliminar Adjunto"}</EuiModalHeaderTitle>
        </EuiModalHeader>
        <EuiModalBody>
         <h2>{onlyConfirm ? `¿Eliminar Adjunto?` : `¿Eliminar el adjunto para todos los partes?`}</h2>
        </EuiModalBody>
        <EuiModalFooter>
          <EuiButton fullWidth color="primary" onClick={()=>onConfirm(true)}>Si</EuiButton>
          {onlyConfirm ? null : <EuiButton fullWidth color="primary" onClick={()=>onConfirm(false)}>No</EuiButton>}
          <EuiButton fullWidth color="danger" onClick={()=>onConfirm(undefined)}>Cancelar</EuiButton>
        </EuiModalFooter>
      </EuiModal>
    </EuiOverlayMask>
  ) : null
}